import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCookieConsent } from '../context/CookieConsentContext';

export default function Footer() {
  const { reopenBanner } = useCookieConsent();
  const { t, i18n } = useTranslation();
  const isEN = i18n.language === 'en';

  const legalLinks = isEN ? [
    { to: '/en/mentions-legales', label: t('legal.footerMentions') },
    { to: '/en/privacy-policy', label: t('legal.footerPrivacy') },
    { to: '/en/terms', label: t('legal.footerCgu') },
    { to: '/en/mentor-charter', label: t('legal.footerCharteMentor') },
    { to: '/en/cookies', label: t('legal.footerCookies') },
    { to: '/en/personal-data', label: t('legal.footerDonnees') },
    { to: '/faq', label: isEN ? 'Help centre' : 'Centre d\'aide' },
    { to: '/contact', label: 'Contact' },
  ] : [
    { to: '/mentions-legales', label: 'Mentions légales' },
    { to: '/politique-de-confidentialite', label: 'Politique de confidentialité' },
    { to: '/cgu', label: 'CGU' },
    { to: '/charte-mentor', label: 'Charte Mentor' },
    { to: '/cookies', label: 'Cookies' },
    { to: '/donnees-personnelles', label: 'Données personnelles' },
    { to: '/faq', label: 'Centre d\'aide' },
    { to: '/contact', label: 'Contact' },
  ];

  return (
    <footer className="border-t border-white/5 pt-6 pb-4 px-4 mt-4" data-testid="site-footer">
      <div className="max-w-4xl mx-auto flex flex-col items-center gap-3">
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-2">
          {legalLinks.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className="text-xs text-[#a0a0ab] hover:text-white transition-colors"
              data-testid={`footer-link-${to.replace(/\//g, '-').replace(/^-/, '')}`}
            >
              {label}
            </Link>
          ))}
          <button
            onClick={reopenBanner}
            data-testid="footer-cookie-prefs-btn"
            className="text-xs text-[#a0a0ab] hover:text-white transition-colors cursor-pointer bg-transparent border-none p-0"
          >
            {t('cookies.footerLink')}
          </button>
        </div>
        <p className="text-xs text-[#a0a0ab] text-center">
          {t('footer.copyright')}
        </p>
      </div>
    </footer>
  );
}
